import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { BlogPost } from '../../../../shared/models/blog.model';
import { BadgeComponent } from '../../../../shared/ui/badge/badge.component';
import { BLOG_COPY } from '../../constants/blog.constants';
import { BlogDatePipe, BlogReadTimePipe } from '../../pipes/blog-format.pipes';

@Component({
  selector: 'app-blog-featured-card',
  imports: [RouterLink, BadgeComponent, BlogDatePipe, BlogReadTimePipe],
  templateUrl: './blog-featured-card.component.html',
  styleUrl: './blog-featured-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class BlogFeaturedCardComponent {
  post = input.required<BlogPost>();

  protected readonly copy = BLOG_COPY;
}
